import { useEffect } from "react";

import { useParams } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";

import EmptyModal from "../../components/modals/EmptyModal";
import ManufactureNewProductForm from "../../components/forms/production/ManufactureNewProductForm";
import AuditActionLink from "../../components/audit/AuditActionLink";
import { ManufacturedProductViewModel } from "../../viewmodels/production/ManufacturedProductViewModel";
import ManufacturedProductLabel from "../../components/forms/production/barcode-label/ManufacturedProductLabel";
import ProductionCostReport from "../../components/forms/production/barcode-label/ProductionCostReport";

function ManufacturedProductDetails(props) {
  const { addSnackbar, logout } = props;

  const { productId } = useParams();

  const {
    loading,
    addIngredientToManufacturedProduct,
    getManufacturedProductIngredients,
    emptyModal,
    getProductReportById,
    claimsOptions,
    manufacturedProduct,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    certifiedByOptions,
    getAssemblyItemReceivingByBarcode,
    getCertifiedByOptionsForDropdown,
    getProductsList,
    updateManufacturedProduct,
    getReceivingAssemblyItemInStockByName,
    deleteIngredientFromManufacturedProduct,
    addManualEntryForManufacturingProduct,
    getManufacturedProductLabel,
    printLabelDetails,
    employeeOptions,
    getUsersForDropdown,
    fetchRecipesForDropdown,
    recipes,
    fetchRecipeItems,
    selectedRecipe,
    setSelectedRecipe,
    showErrorModal,
    printType,
    printProductionCostReport,
    getProductionBatchReport,
    getLabelCheckReport,
    getVacuumPackReport,
    getCookingAndCoolingReport,
    getMetalDetectorReport,
    getClaimsForDropdown,
    supervisorOptions,
    locationOptions,
    productionRoomOptions,
    getLocationsForDropdown,
    loadProductionRoomsForLocation,
    openNitrateAndPhosphateCalculator,
    calculateAmountRequiredForRecipeItems,
    inProcessMonitoringHistory,
    updateInProcessMonitoringHistory,
    previousInProcessMonitoringHistory,
  } = ManufacturedProductViewModel(logout, productId, addSnackbar);

  useEffect(() => {
    async function loadPageData() {
      await Promise.all([
        getClaimsForDropdown(),
        getCertifiedByOptionsForDropdown(),
        getUsersForDropdown(2, [1, 3]),
        getUsersForDropdown(1, [1, 3]),
        fetchRecipesForDropdown(),
        getLocationsForDropdown(),
      ]);
      await getProductReportById(productId);
    }

    loadPageData();
  }, [productId]);

  function renderPrintItem() {
    let html = null;
    if (printType === 1) {
      html = <ManufacturedProductLabel printLabelDetails={printLabelDetails} />;
    } else if (printType === 2) {
      html = (
        <ProductionCostReport
          manufacturedProduct={manufacturedProduct}
          selectedRecipe={selectedRecipe}
        />
      );
    }
    return html;
  }
  return (
    <div className="qatrace-screen qatrace-module-page">
      <div className="hide-for-print mt-2 px-4 sm:px-6 lg:px-8">
        {manufacturedProduct?.id ? (
          <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
            <h1 className="text-xl font-semibold text-gray-900">
              {manufacturedProduct.lot_number
                ? `Lot ${manufacturedProduct.lot_number}`
                : manufacturedProduct.product_name ?? "Manufactured product"}
            </h1>
            <AuditActionLink
              slug="manufactured-product"
              id={manufacturedProduct.id}
              name={
                manufacturedProduct.lot_number ??
                manufacturedProduct.product_name ??
                manufacturedProduct.plu
              }
            />
          </div>
        ) : null}
        {(loading || manufacturedProduct?.id) && (
          <>
          <ManufactureNewProductForm
            loading={loading}
            addIngredientToManufacturedProduct={
              addIngredientToManufacturedProduct
            }
            deleteIngredientFromManufacturedProduct={
              deleteIngredientFromManufacturedProduct
            }
            isEdit={true}
            manufacturedProduct={manufacturedProduct}
            certifiedByOptions={certifiedByOptions}
            employeeOptions={employeeOptions}
            claimsOptions={claimsOptions}
            getManufacturedProductIngredients={
              getManufacturedProductIngredients
            }
            getAssemblyItemReceivingByBarcode={
              getAssemblyItemReceivingByBarcode
            }
            getProductsList={getProductsList}
            updateManufacturedProduct={updateManufacturedProduct}
            setEmptyModelOpen={setEmptyModelOpen}
            setSlideOver={setSlideOver}
            getReceivingAssemblyItemInStockByName={
              getReceivingAssemblyItemInStockByName
            }
            addManualEntryForManufacturingProduct={
              addManualEntryForManufacturingProduct
            }
            getManufacturedProductLabel={getManufacturedProductLabel}
            recipes={recipes}
            fetchRecipeItems={fetchRecipeItems}
            selectedRecipe={selectedRecipe}
            setSelectedRecipe={setSelectedRecipe}
            showErrorModal={showErrorModal}
            printProductionCostReport={printProductionCostReport}
            getProductionBatchReport={getProductionBatchReport}
            getLabelCheckReport={getLabelCheckReport}
            getVacuumPackReport={getVacuumPackReport}
            getCookingAndCoolingReport={getCookingAndCoolingReport}
            getMetalDetectorReport={getMetalDetectorReport}
            supervisorOptions={supervisorOptions}
            locationOptions={locationOptions}
            productionRoomOptions={productionRoomOptions}
            loadProductionRoomsForLocation={loadProductionRoomsForLocation}
            openNitrateAndPhosphateCalculator={
              openNitrateAndPhosphateCalculator
            }
            calculateAmountRequiredForRecipeItems={
              calculateAmountRequiredForRecipeItems
            }
            inProcessMonitoringHistory={inProcessMonitoringHistory}
            updateInProcessMonitoringHistory={updateInProcessMonitoringHistory}
            previousInProcessMonitoringHistory={
              previousInProcessMonitoringHistory
            }
          />
          </>
        )}
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        customClass="max-w-7xl"
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />
      {renderPrintItem()}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManufacturedProductDetails),
);
